import { DEFAULT_LOCALE, STORAGE_KEY_GUEST_LOCALE, isSupportedLocale } from './constants';

function readStorage(key) {
  try {
    var raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return localStorage.getItem(key) || null;
  }
}

function getCookieDomain() {
  var hostname = typeof location !== 'undefined' ? location.hostname : '';
  if (hostname === 'localhost') {
    return 'localhost';
  }
  var dotIndex = hostname.indexOf('.');
  return dotIndex === -1 ? hostname : hostname.slice(dotIndex + 1);
}

function readGuestLocaleCookie() {
  if (typeof document === 'undefined' || !document.cookie) {
    return null;
  }
  var prefix = STORAGE_KEY_GUEST_LOCALE + '=';
  var parts = document.cookie.split('; ');
  for (var i = 0; i < parts.length; i++) {
    if (parts[i].indexOf(prefix) === 0) {
      var raw = decodeURIComponent(parts[i].substring(prefix.length));
      try {
        raw = JSON.parse(raw);
      } catch (e) {
        // cookie value may be a plain locale string
      }
      return isSupportedLocale(raw) ? raw : null;
    }
  }
  return null;
}

function writeGuestLocaleCookie(locale) {
  if (typeof document === 'undefined' || !locale) {
    return;
  }
  var domain = getCookieDomain();
  var exp = new Date();
  exp.setTime(exp.getTime() + 365 * 24 * 60 * 60 * 1000);
  var domainPart = domain === 'localhost' ? '; domain=localhost' : '; domain=.' + domain;
  document.cookie =
    STORAGE_KEY_GUEST_LOCALE +
    '=' +
    encodeURIComponent(JSON.stringify(locale)) +
    domainPart +
    '; path=/; expires=' +
    exp.toUTCString();
}

export function getAppLocaleFromUrl() {
  if (typeof window === 'undefined') {
    return null;
  }
  var href = window.location.href || '';
  var match = href.match(/[?&]appLocale=([^&#]+)/);
  if (!match) {
    return null;
  }
  var locale = decodeURIComponent(match[1]);
  return isSupportedLocale(locale) ? locale : null;
}

export function getGuestLocaleFromStorage() {
  var saved = readStorage(STORAGE_KEY_GUEST_LOCALE);
  if (isSupportedLocale(saved)) {
    return saved;
  }
  return readGuestLocaleCookie();
}

export function saveGuestLocaleToStorage(locale) {
  if (!locale) return;
  localStorage.setItem(STORAGE_KEY_GUEST_LOCALE, JSON.stringify(locale));
  writeGuestLocaleCookie(locale);
}

export function resolveLocale() {
  var fromUrl = getAppLocaleFromUrl();
  if (fromUrl) {
    return fromUrl;
  }
  var guest = getGuestLocaleFromStorage();
  if (guest) return guest;
  var browserLang =
    typeof navigator !== 'undefined' && navigator.language ? navigator.language : '';
  var lang = browserLang.toLowerCase();
  if (lang.indexOf('zh-tw') !== -1 || lang.indexOf('zh-hk') !== -1 || lang.indexOf('zh-hant') !== -1) {
    return 'zh-TW';
  }
  if (lang.indexOf('en') === 0) return 'en';
  return DEFAULT_LOCALE;
}
